import {Badge} from 'react-bootstrap'
import {defineMessages, useIntl, MessageDescriptor} from 'react-intl'

const COLORS: Record<string, string> = {
  COMPLETED: 'success',
  DRAFT: 'warning',
  ARCHIVED: 'secondary',
}

const LABELS: Record<string, MessageDescriptor> = defineMessages({
  COMPLETED: {id: 'commissions.reports.statusFilter.completed', defaultMessage: 'Completed'},
  DRAFT: {id: 'commissions.reports.statusFilter.draft', defaultMessage: 'Draft'},
  ARCHIVED: {id: 'commissions.reports.statusFilter.archived', defaultMessage: 'Archived'},
})

export const BadgeStatus = ({state}: {state: string}) => {
  const intl = useIntl()
  const label = LABELS[state] ? intl.formatMessage(LABELS[state]) : state
  return <Badge bg={COLORS[state]}>{label}</Badge>
}
